import React from 'react';
import {
  Box,
  Typography,
  Icon,
  useMediaQuery,
  useTheme,
  Tooltip,
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { Link } from 'react-router-dom';

import useStyles from './styles';

const Lesson = props => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    completed,
    daysToRelease,
    title,
    courseId,
    id,
    loading,
    empty,
    error,
  } = props;

  const children = (
    <Box className="lesson-content">
      {!loading && (
        <Icon className="lesson-icon" fontSize="small">
          {empty && 'block'}
          {completed && 'check_circle'}
          {!completed && !empty && 'radio_button_unchecked'}
        </Icon>
      )}
      <Box className="lesson-text-container">
        <Typography
          className="lesson-text-title"
          variant="caption"
          noWrap={!isSmallScreen}
        >
          {loading ? <Skeleton variant="text" width="40%" /> : title}
          {empty && 'Sem aulas disponíveis.'}
        </Typography>
      </Box>
      {!loading && !empty && !error && (
        <>
          {daysToRelease !== 0 && (
            <Tooltip
              disableFocusListener
              placement="top"
              title={`Faltam ${daysToRelease} dias`}
            >
              <Icon className="lesson-infos-icon-lock" fontSize="small">
                lock
              </Icon>
            </Tooltip>
          )}
          <Icon className="lesson-infos-icon-go">chevron_right</Icon>
        </>
      )}
    </Box>
  );
  if (loading || empty) {
    return <Box className={`${classes.container} loading`}>{children}</Box>;
  }
  return (
    <Link
      className={`${classes.container} ${completed ? 'completed' : 'next'}`}
      to={`/course/${courseId}/${id}`}
    >
      {children}
    </Link>
  );
};

export default Lesson;
